import { MerchantPlanTypes } from '@frontend/api-payments';
import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { PaymentMethodButtons } from './buttons';

export const PaymentMethodsButtonsStripe = () => {
  const {
    stripeData: { enableACHOnFile, stripeLocationId, enableShareInEmail },
    careCreditData,
    merchant,
    isCareCreditEnabled,
    isDemoLocation,
    careCreditEnrollmentStatus,
  } = useCollectPaymentMultiContext();

  const shouldShowTerminal = () =>
    (!!stripeLocationId &&
      !!merchant?.planName &&
      (merchant?.planName === MerchantPlanTypes.FullPayments || merchant?.planName === MerchantPlanTypes.Full)) ||
    isDemoLocation;

  const showCareCreditAmount = isCareCreditEnabled && ['CARDHOLDER'].includes(careCreditData?.status || '');

  return (
    <>
      <PaymentMethodButtons.ShareInMessage expanded={showCareCreditAmount} />

      {enableShareInEmail && <PaymentMethodButtons.ShareInEmail expanded={showCareCreditAmount} />}

      {shouldShowTerminal() && <PaymentMethodButtons.SelectTerminal expanded={showCareCreditAmount} />}

      <PaymentMethodButtons.CardOnFile enableACHOnFile={enableACHOnFile} expanded={showCareCreditAmount} />

      <PaymentMethodButtons.ManualCardEntry expanded={showCareCreditAmount} />

      {isCareCreditEnabled && (
        <PaymentMethodButtons.CareCredit
          careCreditData={careCreditData}
          expanded={showCareCreditAmount}
          isApplicationDeclined={careCreditEnrollmentStatus?.status === 'declined'}
        />
      )}
      <PaymentMethodButtons.Sunbit expanded={showCareCreditAmount} />
    </>
  );
};
